@if (nodeDetailsDTO) {
  <div class="version-details">
    <div>Server -> version: {{ nodeDetailsDTO.version }}, release date: {{ nodeDetailsDTO.releaseDate }}</div>
    <div>UI -> version: {{ version }}</div>
  </div>
}
